import { render, staticRenderFns } from "./solutionClassify.vue?vue&type=template&id=49703787&scoped=true&"
import script from "./solutionClassify.vue?vue&type=script&lang=js&"
export * from "./solutionClassify.vue?vue&type=script&lang=js&"
import style0 from "./solutionClassify.vue?vue&type=style&index=0&id=49703787&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49703787",
  null
  
)

export default component.exports